import React, { FC, ReactNode, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

interface IInfoSnackbarProps {
    infoMessage: ReactNode;
    onCloseHandler: () => void;
}

export const InfoSnackbar: FC<IInfoSnackbarProps> = ({ infoMessage, onCloseHandler }) => {
    const [open, setOpen] = useState(!!infoMessage);

    const handleClose = (_event: React.SyntheticEvent<any> | Event, reason?: string) => {
        onCloseHandler();
        if (reason === 'clickaway')
            return;

        setOpen(false);
    };

    return (
        <div>
            <Snackbar open={ open } autoHideDuration={ 6000 } onClose={ handleClose } anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <Alert onClose={ handleClose } severity="info" sx={{ width: '100%' }}>
                    { infoMessage }
                </Alert>
            </Snackbar>
        </div>
    );
};
